import React, { useState } from "react";
import "./styles/Explainer.css";
import Modal from "react-modal";

// const info: string = require("../icons/info-8bit.svg").default;

function Explainer() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="explainer">
      <span className="intro" onClick={openModal}>
        {/* <img src={info} alt="info" id="info" /> */}
        What is this?
      </span>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <div className="close-container">
          <div className="close" onClick={closeModal}></div>
        </div>
        <div className="content">
          <p className="content-intro">
            This is where I collect digital ephemera, inspiration and
            occasionally my own words/images. I'm often overwhelmed by the
            quantity of information I encounter on a daily basis. This is an
            attempt to cut through the noise and be more intentional both in
            what I consume and what I choose to remember.
          </p>
          <p className="content-header">
            <b>Navigation</b>
          </p>
          <p>✿ Click on a thought to view it in full.</p>
          <p>
            ✿ Some thoughts are tagged. Those with shared tags are grouped
            together. All tags from a given week/selection are displayed
            top-left.
          </p>
          <p className="content-header calendar">
            <b>Calendar View</b>
            <br></br>
            <i>recommended</i>
          </p>
          <p>
            Opacity is determined by recency. Thoughts are full opacity the week
            they're added&nbsp;
            <span className="fade-75">then</span>
            <span className="fade-6"> fade</span>
            <span className="fade-5"> over</span>
            <span className="fade-4"> time.</span>
          </p>
          <p className="content-header">
            <b>Topic View</b>
          </p>
          <p> All thoughts with a shared tag, across all weeks.</p>
        </div>
      </Modal>
    </div>
  );
}

export default Explainer;
